import React from "react";
import "./RequestVoting.scss";
import { useTranslation } from "react-i18next";
import { ReactComponent as RV } from "../../../assets/images/ReqestVoiting.svg";

const RequestVoting = () => {
  const { t } = useTranslation();

  return (
    <a className="request_btn" href="https://feedback.ultrade.org/boards/suggestions-and-feature-requests" target="blank">
      <RV />
      {t("footer.request_voting_text")}
      <i className="fa fa-angle-right" aria-hidden="true"></i>
    </a>
  );
};

export default RequestVoting;
